<div
  class="flex h-full w-full flex-wrap content-center justify-center rounded-lg p-5">
  <div class="text-center">
    <div class="text-2xl font-bold">{{ title || 'wentWrong' | translate }}</div>
    @if (description) {
      <p class="text-md mt-5 text-gray-700">
        {{ description }}
      </p>
    }
    <div class="mt-2">
      @if (showPicture) {
        <img
          src="../../../../assets/something-went-wrong.svg"
          alt="something-went-wrong" />
      }
    </div>
    @if (showRetryButton) {
      <button mat-flat-button color="primary" (click)="onRetryBtnClicked()">
        {{ 'retry' | translate }}
      </button>
    }
  </div>
</div>
